import _ from 'underscore';

export const getDefaultPlugins = ({
  pluginFactories,
  gridOptions,
  useEditablePlugin = false,
  appConfig,
  perfMarker,
}) => _.compact([
  { plugin: pluginFactories.perfMarkerPlugin, config: { appConfig, marker: perfMarker } },
  {
    plugin: pluginFactories.toolbarPlugin,
  },
  {
    plugin: pluginFactories.paginationPlugin,
    config: gridOptions.plugins.pagination,
  },
  {
    plugin: pluginFactories.dateFilterPlugin,
    config: gridOptions.plugins.dateFilter,
  },
  {
    plugin: pluginFactories.columnChooserPlugin,
    config: gridOptions.plugins.columnChooser,
  },
  {
    plugin: pluginFactories.placeholderPlugin,
    config: gridOptions.plugins.placeholder,
  },
  {
    plugin: pluginFactories.uiBlockerPlugin,
    config: gridOptions.plugins.uiBlocker,
  },
  {
    plugin: pluginFactories.inlineDownload,
    config: gridOptions.plugins.inlineDownload,
  },
  {
    plugin: pluginFactories.newPerformanceLogPlugin,
    config: gridOptions.plugins.performanceLogNew,
  },
  useEditablePlugin && {
    plugin: pluginFactories.editablePlugin,
    config: gridOptions.plugins.editable,
  },
  useEditablePlugin && {
    plugin: pluginFactories.crossPageSelectAllPlugin,
  },
  useEditablePlugin && {
    plugin: pluginFactories.inlineErrorPlugin,
  },
]);
